import {
	forwardRef,
	MouseEvent,
	PropsWithChildren,
	ReactElement,
	Ref,
	useCallback,
	useContext
} from "react";
import classNames from "classnames";
import { ButtonBase } from "../../../ButtonBase/ButtonBase";
import {
	ControlAttachmentContext,
	ControlAttachmentOptions,
	getAttachmentClassNames
} from "../../../ControlAttachment";
import { EMPTY_ARRAY } from "client/Misc/utils";
import styles from "./Button.module.less";

export type ButtonProps = {
	isActive?: boolean;
	isDisabled?: boolean;
	onClick(): void;
	attachedOn?: ControlAttachmentOptions;
	handleOn?: "mousedown" | "click";
	trackingId?: string;
	tooltip?: string;
};

export const Button = forwardRef<HTMLButtonElement, PropsWithChildren<ButtonProps>>(
	(props: PropsWithChildren<ButtonProps>, ref: Ref<HTMLButtonElement>): ReactElement => {
		const {
			isActive = false,
			isDisabled = false,
			onClick,
			attachedOn = EMPTY_ARRAY,
			handleOn = "mousedown",
			trackingId,
			tooltip,
			children
		} = props;

		const {
			attachedOn: attachmentsFromContext
		} = useContext(ControlAttachmentContext);

		const mouseDownHandler = useCallback(
			(event: MouseEvent) => {
				event.preventDefault();
				if (handleOn === "mousedown") {
					onClick();
				}

			},
			[handleOn, onClick]
		);

		const clickHandler = useCallback(
			() => {
				if (handleOn === "click") {
					onClick();
				}
			},
			[handleOn, onClick]
		);

		return (
			<ButtonBase
				ref={ref}
				className={classNames(
					styles.root,
					{
						[styles.root_active]: isActive,
						[styles.root_disabled]: isDisabled
					},
					getAttachmentClassNames(attachedOn, attachmentsFromContext)
				)}
				onMouseDown={mouseDownHandler}
				disabled={isDisabled}
				onClick={clickHandler}
				trackingId={trackingId}
				title={tooltip}
			>
				{children}
			</ButtonBase>
		);
	}
);
Button.displayName="RichTextEditorToolbar.Button";